import { render, staticRenderFns } from "./fileDirectory.vue?vue&type=template&id=12a2d814"
import script from "./fileDirectory.vue?vue&type=script&lang=js"
export * from "./fileDirectory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports